(function () {
  function initReviewsSliders() {
    var sliders = document.querySelectorAll('[data-reviews-slider]');
    if (!sliders.length) return;

    sliders.forEach(function (slider) {
      if (slider.dataset.rvInitialized === 'true') return;
      slider.dataset.rvInitialized = 'true';

      var track = slider.querySelector('[data-rv-track]');
      var prevBtn = slider.querySelector('[data-rv-prev]');
      var nextBtn = slider.querySelector('[data-rv-next]');
      var dotsContainer = slider.querySelector('[data-rv-dots]');
      var slides = slider.querySelectorAll('[data-rv-slide]');
      if (!track || slides.length === 0) return;

      var totalSlides = slides.length;
      var currentIndex = 0;
      var gap = 24;

      function getSlidesPerView() {
        var w = window.innerWidth;
        var desktop = parseInt(slider.dataset.slidesDesktop || '2', 10);
        var tablet = parseInt(slider.dataset.slidesTablet || '1', 10);
        var mobile = parseInt(slider.dataset.slidesMobile || '1', 10);
        if (w >= 990) return desktop;
        if (w >= 768) return tablet;
        return mobile;
      }

      function getTotalPages() {
        var perView = getSlidesPerView();
        return Math.max(1, totalSlides - perView + 1);
      }

      function createDots() {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        var totalPages = getTotalPages();
        for (var i = 0; i < totalPages; i++) {
          var dot = document.createElement('button');
          dot.className = 'rv-dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('type', 'button');
          dot.setAttribute('aria-label', 'Page ' + (i + 1));
          (function (idx) {
            dot.addEventListener('click', function () {
              currentIndex = idx;
              updateSlider();
            });
          })(i);
          dotsContainer.appendChild(dot);
        }
      }

      function updateSlider() {
        var perView = getSlidesPerView();
        var maxIndex = Math.max(0, totalSlides - perView);
        if (currentIndex > maxIndex) currentIndex = maxIndex;
        if (currentIndex < 0) currentIndex = 0;

        var slideWidth = slides[0].getBoundingClientRect().width;
        var offset = currentIndex * (slideWidth + gap);
        track.style.transform = 'translateX(-' + offset + 'px)';

        slides.forEach(function (slide, i) {
          if (i >= currentIndex && i < currentIndex + perView) {
            slide.classList.add('is-active');
          } else {
            slide.classList.remove('is-active');
          }
        });

        if (prevBtn) prevBtn.disabled = currentIndex <= 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;

        if (dotsContainer) {
          var dots = dotsContainer.querySelectorAll('.rv-dot');
          dots.forEach(function (dot, i) {
            if (i === currentIndex) {
              dot.classList.add('is-active');
            } else {
              dot.classList.remove('is-active');
            }
          });
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          currentIndex = Math.max(0, currentIndex - 1);
          updateSlider();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          var maxIndex = Math.max(0, totalSlides - getSlidesPerView());
          currentIndex = Math.min(maxIndex, currentIndex + 1);
          updateSlider();
        });
      }

      var startX = 0;
      var isDragging = false;

      function handleTouchStart(e) {
        startX = e.touches ? e.touches[0].clientX : e.clientX;
        isDragging = true;
      }

      function handleTouchEnd(e) {
        if (!isDragging) return;
        isDragging = false;
        var endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
        var diff = startX - endX;
        if (Math.abs(diff) > 50) {
          var maxIndex = Math.max(0, totalSlides - getSlidesPerView());
          if (diff > 0) {
            currentIndex = Math.min(maxIndex, currentIndex + 1);
          } else {
            currentIndex = Math.max(0, currentIndex - 1);
          }
          updateSlider();
        }
      }

      track.addEventListener('touchstart', handleTouchStart, { passive: true });
      track.addEventListener('touchend', handleTouchEnd, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          createDots();
          updateSlider();
        }, 150);
      });

      createDots();
      updateSlider();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewsSliders);
  } else {
    initReviewsSliders();
  }

  document.addEventListener('shopify:section:load', initReviewsSliders);
  document.addEventListener('shopify:block:select', initReviewsSliders);
})();
